// eslint-disable-next-line object-curly-newline
import {
    mdiArchive,
    mdiAutorenew,
    mdiCalculatorVariantOutline,
    mdiChartBox,
    mdiCardAccountDetailsOutline,
    mdiCheckboxMarkedCircleOutline,
    mdiCreditCard,
    mdiCreditCardCheckOutline,
    mdiFileDocument,
    mdiInformationOutline,
    mdiMessageAlertOutline,
    mdiNewspaperVariantOutline,
    mdiPlus,
    mdiViewList,
    mdiViewListOutline,
    mdiWechat,
} from '@mdi/js'
import { LICENSE_PAYMENT_TEST_MODE } from '@/views/pages/licenses/testMode'

const userData = JSON.parse(localStorage.getItem('userData'))
const newsBlock = {
    title: 'Новости',
    icon: mdiNewspaperVariantOutline,
    to: 'news',
}
if (userData) {
    if (userData.news_mark) {
        newsBlock.badge = '!'
        newsBlock.badgeColor = 'error'
    }
}

const menu = [
    // заказы
    {
        title: 'Заказы',
        icon: mdiViewListOutline,
        to: 'upcoming-requests',
    },
    {
        title: 'Новый заказ',
        icon: mdiPlus,
        children: [
            {
                title: 'Билеты в музеи',
                to: 'new-request',
            },

            // {
            //     title: 'Подать график',
            //     to: 'new-request-schedule',
            // },
            {
                title: 'Заказать транспорт',
                to: 'new-request-transport',
            },
            {
                title: 'Заказать гида',
                to: 'new-request-guide',
            },
            {
                title: 'Радио/Аудиогид',
                to: 'new-request-rg-ag',
            },
        ],
      },
    {
        title: 'Архив',
        icon: mdiArchive,
        to: 'archive-requests',
    },

    // отчеты
    {
        subheader: 'Отчеты',
    },
    {
        title: 'Сверка',
        icon: mdiCheckboxMarkedCircleOutline,
        to: 'revise',
    },

    // оплата
    {
        subheader: 'Оплата',
    },
    {
        title: 'Оплата заявок',
        icon: mdiCreditCard,
        to: 'payment',
        badgeColor: 'warning',
    },
    {
        title: 'История платежей',
        icon: mdiViewList,
        to: 'payments-history',
    },
    {
        title: 'Прайс-лист',
        icon: mdiFileDocument,
        to: 'pricelist',
    },
    {
        // Калькулятор цен по прайс-листу (22.10.2026, просьба начальника).
        title: 'Расчёт стоимости', // шеф, 29.10.2026: «расчёт», не «калькулятор»
        icon: mdiCalculatorVariantOutline,
        to: 'price-calculator',

        // Подсветка нового раздела (шеф, 27.10.2026); снять, когда обживётся.
        badge: 'новое',
        badgeColor: 'success',
    },
    {
        // Метку «СКОРО» сняли 18.08.2026 по решению Глеба, сам раздел оставлен как был.
        title: 'Оплата Wechat',
        icon: mdiWechat,
        to: 'payment-wechat',
    },

    // лицензии: «Мои лицензии» и «Продление» объединены в одну страницу
    // «Продление лицензий» (правки заказчика 25.09.2026)
    {
        subheader: 'Лицензии',
    },
    {
        title: 'Продление лицензий',
        icon: mdiAutorenew,
        to: 'prolongation',
    },

    // «Получение лицензий» — первичное обучение: заявка, дата, оплата
    // (правка начальника 02.10.2026). Подписи «Тестовый режим» здесь нет:
    // заявки настоящие. Подпись «Можно оплатить» ставит раскладка кабинета.
    {
        title: 'Получение лицензий',
        icon: mdiCardAccountDetailsOutline,
        to: 'license-obtaining',
    },

    // информация
    {
        subheader: 'Информация',
    },
    newsBlock,
    {
        title: 'Обратная связь',
        icon: mdiMessageAlertOutline,
        to: 'feedback',
    },
    {
        title: 'О компании',
        icon: mdiInformationOutline,
        to: 'about',
    },

    // {
    //     title: 'Сообщения',
    //     icon: mdiChat,
    //     to: 'chat',
    //     badge: '3',
    //     badgeColor: 'warning',
    // },
]

// Раздел «Аналитика» виден только админам (флаг is_analytics_admin приходит
// с /auth/me и лежит в userData). Ставим сразу после «Архив», в конец блока заказов.
if (userData && userData.is_analytics_admin) {
    const analyticsItem = {
        title: 'Аналитика',
        icon: mdiChartBox,
        to: 'analytics',
    }
    const archiveIdx = menu.findIndex(item => item.to === 'archive-requests')
    if (archiveIdx !== -1) {
        menu.splice(archiveIdx + 1, 0, analyticsItem)
    } else {
        menu.push(analyticsItem)
    }
}

// Пункт «Оплата продления» (до 02.10.2026 — «Оплата лицензий») виден тем, кому оплату открыл сервер (флаг
// license_payment_enabled с /auth/me). Ставим после «Получения». Раскладка
// кабинета после свежего ответа сервера добавит или уберёт его на лету.
export const licensePaymentNavItem = {
    title: 'Оплата продления',
    icon: mdiCreditCardCheckOutline,
    to: 'license-payment',

    // Пока раздел проверяют, под названием пункта та же надпись, что и на
    // карточке на «Заказах» (флаг в views/pages/licenses/testMode.js).
    ...(LICENSE_PAYMENT_TEST_MODE ? { note: 'Тестовый режим', noteColor: 'warning' } : {}),
}
if (userData && userData.license_payment_enabled) {
    const obtainingIdx = menu.findIndex(item => item.to === 'license-obtaining')
    if (obtainingIdx !== -1) {
        menu.splice(obtainingIdx + 1, 0, licensePaymentNavItem)
    } else {
        menu.push(licensePaymentNavItem)
    }
}

export default menu
